
<template>
  <printstickerin-component>
  <div class="animated fadeIn">
    <b-row >
      <b-col sm="12">
        <b-card>
          <div slot="header">
            
            <strong>In Pallet</strong>
          
          </div>
          <div id="printableArea" >
            <div class="page-break" v-for="item in printdata" >
              <table>
                  <tr >
                    <td >
                     <div>
                      <table border = '1' class="stickertable"  >
                        <tr>

                          <td>
                          <div style='text-align: center;font-size: 0px;'>
                          <img id='test'/>
                          <div id="app" >

                          <barcode v-bind:value="item.shippingid">
                          Show this if the rendering fails.
                          </barcode>
                          </div>
                          </div>
                          </td>
                        </tr>

                      <tr>
                        <td colspan ='2' class="addpad">

                          <span style ='font-size: 25px;'><b>{{item.customername}}</b></span> <br>
                          <span style ='font-size: 20px;'> {{item.pickuplocationaddress}}</span><br>
                          <span style ='font-size: 20px;'>Contact:<b> {{item.pocmobilenumber}}</b></span><br>
                          <span style ='font-size: 20px;'>Vendor Name:<b>{{item.vendor_name}}</b></span><br>
                          <span style ='font-size: 20px;'>Zone Name: {{item.zone_name}}</span><br>
                          <span style ='font-size: 20px;'>POID: {{item.orderid}}</span><br>
                          <span style ='font-size: 20px;'>FCID: {{item.productid}}</span><br>
                          <span style ='font-size: 20px;'>Quantity: {{item.productquantity}}</span>
                          <br>
                           <span style ='font-size: 20px;'>Sr Reason: {{item.sr_reason}}</span>
                          <br>
                        </td>
                      </tr>
                     
                     </table>
                   </div>
                    </td>
                  </tr>
                </table>
            </div>           
          </div>
           <b-row class="mb-12">
             
             <!--  <b-col md="4" class="my-1">
                <b-col md="12">
                <b-form-group label="DeliveryAgent" :label-cols="4" >
                 <b-form-select class="form-control input" v-model="deliveryagentid" name="deliveryagentid" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="agent in agentmaster" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                  </b-form-select>
               </b-form-group>
             </b-col>
              </b-col> -->
             <!--  <b-col md="4">
                <b-col md="12">
                <b-form-group label="Status":label-cols="4" >
                  <b-form-select v-model="shipmentstatus" name="shipmentstatus" class="mySelectBox" v-validate="'required'" :onclick="status()">
                    <option :value="selected">--Selected Status-</option>
                    <option value="handoverpending">Total NDR</option>
                    <option value="notattempted">Not Attempted</option>
                    <option value="notassigned">Not Assigned</option>
                    <option value="RTO">RTO</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              </b-col> -->
              
            </b-row>

              <b-row class="mb-12">
                 <!--  <b-col md="4">
                <b-col md="12">
                <b-form-group label="Pallet Master":label-cols="4" >
                  <b-form-select v-model="pallet_master" name="pallet_master" class="mySelectBox" v-validate="'required'" >
                   
                    <option value="">--Select Pallet--</option>
                    <option value="inpallet">In Pallet</option>
                    <option value="outpallet">Out Pallet</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              </b-col> -->
                <b-col md="4" class="my-1">
                  <b-col md="12">
                <b-form-group label="Pallet" :label-cols="3" >
                 <b-form-select @change="displayzoneid()" class="form-control input" v-model="pallet_id" name="pallet_id" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="pallet in pallet_items" v-bind:value="pallet.pallet_id">
                          {{pallet.pallet_title}}
                        </option>
                  </b-form-select>
               </b-form-group>
               </b-col>
              </b-col>
              <b-col md="4" class="my-1" >
                <b-col md="12">
                <b-form-group label="Zone" :label-cols="4" >
                 <b-form-select class="form-control input" v-model="zone_id" name="zone_id" >
                        <option :value="selected" >--Select--</option>
                        <option v-for="zone in zone_items" v-bind:value="zone.zone_name">
                          {{zone.zone_name}}
                        </option>
                  </b-form-select>
               </b-form-group>
             </b-col>
              </b-col>
              <!--   <b-col md="4">
                <b-col sm="12">
                <b-form-group label="From Date"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
              </b-col> -->     
             </b-row>
             <b-row class="mb-12">
             
               <!-- <b-col md="4">
                <b-col md="12">
                <b-form-group label="To Date"  :label-cols="3" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
              </b-col> -->
               <b-col md="4" class="my-1">
                 <b-col md="12">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              </b-col>

              <b-col md="2">
                <b-col md="12">
         <b-button type="submit" size="md" variant="primary" @click="showlist"> Search</b-button>
        </b-col>
              </b-col>
          </b-row>
          <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red; float: right;">{{ this.totalRows }}</span></b> </p>
                 <b-row >
                  <b-col sm="12" class="text-left">
                  <span v-if="this.totalRows>0">
                    <input type='checkbox' @click='checkAll()' v-model='isCheckAll' id="allseleted" >
                 Select All</span>
                  <b-button style="display: none; margin-left: 15px; " id="printbutton" variant="primary" size="md" value="print a div!" @click="barcodedata('printableArea')">Print Receipt</b-button>
                </b-col>
                </b-row>
              </b-col>
              <b-col sm="12">
            <b-table  show-empty stacked="md" :busy="isBusy" :items="items" :fields="fields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" >

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>


            <template slot="checkbox" slot-scope="row">
            <br/>
            <input @change="setStickerHTMl($event)" type="checkbox"  v-bind:value="row.item.awbno" class="shipmentscheckbox"  v-model="checkedShipmentID" >
            {{row.item.selected}}
            </template>
            <template slot="show_details" slot-scope="row">
            <br/>
              <b-button size="sm" @click="row.toggleDetails();" class="mr-2">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
              </b-button>

            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row>

                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
                  </div>
                 </b-col>
                </b-row>

              </b-card>
            </template>

          </b-table>
        </b-col>
          <b-col md="6" class="my-1" v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
  </div>
</printstickerin-component>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueBarcode from 'vue-barcode';
export default {
  data: function() {
    return {
      data: [],
      checkedShipmentID:[],
      items:[],
      customer:{},
      selected:'',
      isBusy: false,
      orderflow:'',
      Pickup:'',
      email:'',
      shipmenttype:'',
      shipmentstatus:'',
      // pallet_master:'',
      hubid:'',
      deliveryagentid:'',
      zone_id:'',
      pallet_id:'',
      agentmaster: [],
      zone_items:[],
      pallet_items:[],
      showdata: [],
      hubdata:[],
      printdata:[],
      progressbar:[],
      progressbar:[],
      orderid:[],
      barcodes:[],
       selectDateFrom:null,
        selectDateTo:null,
      barcodeValue:['test2243'],

      ordercodeValue:['5CD1332458'],

      shippingidx:[],
      printstickerdata:[],

      fields: [
          { key: 'checkbox', label: 'Select', sortable: true},
          { key: 'orderid', label: 'Orderid', sortable: true, sortDirection: 'desc' },
          { key: 'awbno', label: 'AWBno', sortable: true},
          { key: 'customername', label: 'Customername', sortable: true},
          { key: 'pallet_title', label: 'PalletTitle', sortable: true},
          { key: 'zone_name', label: 'ZoneName', sortable: true},
          { key: 'destination', label: 'Destination', sortable: true },
          { key: 'deliverystatus', label: 'DeliveryStatus', sortable: true },
          { key: 'shipmentstatus', label: 'ShipmentStatus', sortable: true },

        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        isCheckAll: false,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
    };
  },
   components: {
    'barcode': VueBarcode
  },



  computed: {
    sortOptions() {
      }
  },
  created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hubid=userInfo.pickuplocationmasterid.toString();
    // this.displaydeliveryagent();
    this.showlist();
    this.displaypalletid();
    // this.displayzoneid();
  },
  methods: {
    info(item, shipmentid,index, button) {

      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    checkAll: function(){
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      this.isCheckAll = !this.isCheckAll;
      this.checkedShipmentID = [];
      // console.log(this.items[0].awbno);
      if(this.isCheckAll){ // Check all
        for (var key in this.items) {
          this.checkedShipmentID.push(this.items[key].awbno);

        }
         document.getElementById("printbutton").style.display ="block";
         var shippingidobj = { shippingid :this.checkedShipmentID ,
           hub_id:`${userInfo.pickuplocationmasterid}`,


         };

this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/printsticker`,shippingidobj)
            .then(result => {

              this.printdata = result.body.returnvalue;

            })
            .catch(ex => {
              console.log('error-----', ex)
            });

      }
      else{
        document.getElementById("printbutton").style.display ="none";
      }
      // console.log(this.checkedShipmentID);

    },
    updateCheckall: function(){

      if(this.checkedShipmentID.length == this.items.length){
         this.isCheckAll = true;
      }else{
         this.isCheckAll = false;
      }
    },

     /*
     * Function to get Data for Selected Shipment ID
     * Created By: Sachin
     * Created On : 23/01/2020
     */

    setStickerHTMl(e){
 var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

        if (this.checkedShipmentID.length >0)

        {

            document.getElementById("printbutton").style.display ="block";

            var shippingidobj = { shippingid :this.checkedShipmentID ,
               hub_id:`${userInfo.pickuplocationmasterid}`,

            };

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/printsticker`,shippingidobj)
            .then(result => {

              this.printdata = result.body.returnvalue;

            })
            .catch(ex => {
              console.log('error-----', ex)
            });



        }
        else{
          document.getElementById("printbutton").style.display ="none";
        }

    },
       formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },



    barcodedata(printableArea){


      //document.getElementById("printableArea").style.display = "none";

     var printContents = document.getElementById("printableArea").innerHTML;


     // var originalContents = document.body.innerHTML;
     // document.body.innerHTML = printContents;
     // window.print();
     // document.body.innerHTML = originalContents;


    var disp_setting="toolbar=yes,location=no,";
    disp_setting+="directories=yes,menubar=yes,";
    disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
       var content_vlue = printContents;
       var docprint=window.open("","",disp_setting);
       docprint.document.open();
       docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
      docprint.document.write('<head>');
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write('font-family:verdana,Arial;color:#000;');
      docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:20px;}');
      docprint.document.write('a{color:#000;text-decoration:none;} ');
      docprint.document.write('.stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} ');
      docprint.document.write('.printarea{ font-size: 30px;text-align: center;}');

      docprint.document.write('.addpad{ padding: 10px; }');


       docprint.document.write('@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}');

docprint.document.write('@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }');        


        docprint.document.write('.stickertable td{ padding-bottom:10px;  }');

        docprint.document.write('@page { size: 101.6mm 152.4mm;}</style>');


        //docprint.document.write('@media print { td.page-break  { display: block; page-break-before: always; } } </style>');  


  

       docprint.document.write('</head><body onLoad="self.print()"><center>');



       // docprint.document.write('<script type="text/javascript">function CloseWindow() { window.close() }');


        // docprint.document.write('<a  onclick="CloseWindow();" href="#">Here</a> to close this window.');
       docprint.document.write(content_vlue);
docprint.document.write('</center></body></html>');
           docprint.document.close();
      // localStorage.removeItem("reloaded");
     // location.reloaded();
       //self.close();


    },



    CloseWindow() {
        docprint.close();
    },




    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {},
    trybuyaddawb:function() {
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(userInfo.pickuplocationmasterid);

      const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
       this.$http
        .post(`${CONSTANTS.API_URL}/getmisreport`,obj)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);


           // alert('MIS Report Downloaded Successfully');
           this.$fire({
                  text:"MIS Report Downloaded Successfully",
                  type: "success",
                  timer: 30000
                }); 
            //document.getElementById("loader").style.display = 'none';
          } else {
             // alert(result.body.returnmsg);
              this.$fire({
                  text:result.body.returnmsg,
                  type: "error",
                  timer: 30000
                }); 


          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
     },
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },
    downloadCSV: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var orderflow=(this.orderflow!=null)? this.orderflow:"";
      var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
      var csvObj = {
        orderflow:orderflow,
        deliveryagentid:deliveryagentid,
        hub_id:`${userInfo.pickuplocationmasterid}`,

      };
      var r = Math.random().toString(36).substring(3);
      this.$http
        .post(`${CONSTANTS.API_URL}/getmisreport?c=`+r, csvObj)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);

           // alert('MIS Report Downloaded Successfully');
           this.$fire({
                  text:"MIS Report Downloaded Successfully",
                  type: "success",
                  timer: 30000
                }); 
            //document.getElementById("loader").style.display = 'none';
          } else {
             // alert(result.body.returnmsg);
             this.$fire({
                  text:result.body.returnmsg,
                  type: "error",
                  timer: 30000
                }); 


          }
        })
        .catch(ex => {
          console.log("error-----", ex);
        });
    },
    showlist: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
       this.isBusy = true;
    // var deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid:"";
    // var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
    // var pallet_master=(this.pallet_master!=null)? this.pallet_master:"";
    var pallet_id=(this.pallet_id!=null)? this.pallet_id:"";
    var zone_id=(this.zone_id!=null)? this.zone_id:"";
    // var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        // var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        var csvObj = {
          // deliveryagentid:deliveryagentid,
          // shipmentstatus:shipmentstatus,
          // fromdate: `${fromdate}`,
          // todate:`${formatdateto}`,
          hub_id:`${userInfo.pickuplocationmasterid}`,
          // pallet_id:`${userInfo.pickuplocationmasterid}`,
          // zone_id:`${userInfo.pickuplocationmasterid}`,
          palletmaster:"inpallet",
          pallet_id:pallet_id,
          zone_name:zone_id,
        };


this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getreverseshipmentlist`,csvObj)
          .then(result => {
             this.isBusy = !this.isBusy;
             localStorage.removeItem('printableArea');
             this.isCheckAll = false;
             this.checkedShipmentID = [];
              document.getElementById("printbutton").style.display ="none";            
            if (result.body.returnmsg && result.body.returnmsg === 'NoRecordsFound') {
              
              // console.log(this.showdata)
              this.showdata = []
              this.items  = result.body.returnvalue;
               // console.log(this.items)
              this.totalRows = 0;

            } else if (result.body.length === 0) {
              this.showdata = []
              this.items  = [];
              this.totalRows = 0;

            } else if (result.body.returnmsg === 'error') {
             this.showdata = []
              this.items  = [];
              this.totalRows = 0;
               // alert(result.body.returnvalue);
                 this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 

            } else if (result.body.returnmsg === 'InputException') {
              this.showdata = []
              this.items  = [];
              this.totalRows = 0;
               // alert(result.body.returnvalue);
                 this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 

            }else if (result.body.returnmsg === 'DBException') {
              this.showdata = []
              this.items  = [];
              this.totalRows = 0;
               // alert(result.body.returnvalue);
               this.$fire({
                  text:result.body.returnvalue,
                  type: "error",
                  timer: 30000
                }); 

            } else {
              this.isCheckAll = false;
             this.checkedShipmentID = [];
              document.getElementById("printbutton").style.display ="none";
                this.showdata = result.body.returnvalue;
                this.items  = result.body.returnvalue;

                this.totalRows = result.body.returnvalue.length;

            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });

    },

     status: function() {

    if(this.shipmentstatus=="notassigned")
     {

     var csvObj = {

          shipmentstatus:"notassigned"

        };

      }
      else if(this.shipmentstatus=="handoverpending")
      {

      var csvObj = {

        shipmentstatus:"handoverpending"

      };

      }
       else if(this.shipmentstatus=="RTO")
      {

      var csvObj = {

        shipmentstatus:"RTO"

      };

      }
      else if(this.shipmentstatus=="notattempted")
     {

     var csvObj = {

          shipmentstatus:"notattempted"

        };

      }
     },

    displayHubdata: function() {
    const deliveryagentobj = {
       hub_id:`${userInfo.pickuplocationmasterid}`,
    }
    this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getallhublist`,deliveryagentobj)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },

    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
          hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    displaypalletid: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // Pallet
     const obj = {
      
         hub_id:`${userInfo.pickuplocationmasterid}`,

      }
      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getpalletrecordslisting`,obj)
        .then((result) => {
           // console.log("palletResult",result);
          if (result.body.returnmsg="Successful") {
             this.pallet_items  = result.body.returnvalue;

             // console.log("pallet",this.pallet_items);   
          } else {
            this.pallet_items =[];
            
          }

        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
     displayzoneid: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //zone name
       const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
        pallet_id:this.pallet_id,
      };

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getzonelistforprintsticker`,obj)
        .then((result) => {
         // console.log("Hiii",result);
           if (result.body.returnmsg === 'Successful') {
             this.zone_items  = result.body.returnvalue;
             // console.log("zone",  this.zone_items);
          } else {
            this.zone_items=[];
          }
          // this.agentmaster = result.body
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
.stickertable{
     border-collapse: collapse;margin-bottom: 20px; page-break-after:always;
;width:360px;height:540px;

}
.printarea{
  font-size: 20px;text-align: center;
}

.stickertable td{
  padding-bottom:10px;
   page-break-after:always;

}

@media all {
.page-break { display: none; }
}

@media print {
.page-break { display: block; page-break-before: always; }
}
.addpad{
  padding: 10px;
}        
</style>
